import React from 'react';

const SvgRenderer = ({ svg_string }) => {
          return (
                <img src={`data:image/svg+xml;utf8,${encodeURIComponent(svg_string)}`} />
          )
};

export default SvgRenderer;
